<template>
<div>
  <div class="col-lg-12">
    <div class="col-lg-4">
      <table class="table table-striped" v-if="user.admin || user.roles.includes('ppc')">
        <tbody v-if="site.ipProvider && site.integrations.ip">
        <tr>
          <td colspan="2">
            {{ site.ipProvider.name }}
            <img :src="'/static/img/' + site.ipProvider.integration + '.png'" :alt="site.ipProvider.integration" style="max-height: 12px;" class="pull-right" v-tooltip="site.ipProvider.integration">
          </td>
        </tr>
        <tr>
          <td>Status</td>
          <td>
            <span class="label label-primary" v-if="site.integrations.ip.status === 'active'"><i class="fa fa-check"></i> Active</span>
            <span class="label label-warning" v-else><i class="fa fa-warning"></i> {{ site.integrations.ip.status }}</span>
          </td>
        </tr>
        <tr v-if="site.integrations.ip.nameServers">
          <td>Dns</td>
          <td>
            {{ site.integrations.ip.nameServers.join(',') }}
            <span v-if="site.whois && site.integrations.ip.nameServers === site.whois.ns">
              <i class="fa fa-check-circle green" v-tooltip="'Nameservers pointed to CloudFlare'"></i>
            </span>
            <span v-else>
              <span v-if="user.admin && site.registrar && site.registrar.integration && site.registrar.integration.canUpdateNS">
                <a @click="setNs(site.integrations.ip.nameServers)"><i class="fa fa-upload pull-right" v-tooltip="'Point nameservers to CF'"></i></a>
              </span>
            </span>
          </td>
        </tr>
        <tr>
          <td>SSL</td>
          <td>
            <a-edit-txt
              type="select"
              :selected-value="site.integrations.ip.settings && site.integrations.ip.settings.ssl ? site.integrations.ip.settings.ssl.value : '?'"
              :options="['off', 'flexible', 'full', 'strict']"
              :text="site.integrations.ip.settings && site.integrations.ip.settings.ssl && site.integrations.ip.settings.ssl.value ? site.integrations.ip.settings.ssl.value : '?'"
              @input="updateCfSettings('ssl', $event)"
              close-on-save="true"
              :locked="!user.admin"
            ></a-edit-txt>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="2">
            <v-select :options="f.ipProviders" label="name" index="id" v-model="selectIpProvider"></v-select>
          </td>
        </tr>
        <tr v-if="selectIpProvider">
          <td colspan="2">
            <button class="btn btn-primary btn-xs" @click="assignIpProvider"><i class="fa fa-save"></i> Assign &amp;amp; set up</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="col-lg-8">
      <div class="loader m-t-md" v-if="!dnsRecords.data"></div>
      <table class="table table-borderless" v-else>
        <thead>
        <tr>
          <th>Type</th>
          <th>Name</th>
          <th>Value</th>
          <th>
            <button class="btn btn-primary btn-xs" @click="showAddRecord = true"><i class="fa fa-plus"></i> Add</button>
            <button
              class="btn btn-primary btn-xs"
              @click="addDefaultRecords"
              v-if="site.customData.doServer && !this.pointsToServer"
            >
              <i class="fa fa-arrow-circle-o-right"></i>
              Point to {{ site.customData.doServer }}
            </button>
          </th>
        </tr>
        </thead>
        <tbody v-if="showAddRecord">
        <tr>
          <td>
            <v-select
              :options="recordTypes"
              v-model="newRecord.type"
              placeholder="Type"
            ></v-select>
            <input type="checkbox" name="" id="" v-tooltip="'Proxied'" v-model="newRecord.proxied">
          </td>
          <td>
            <input type="text" class="form-control" v-model="newRecord.name">
          </td>
          <td>
            <input type="text" v-model="newRecord.content" class="form-control">
            <input type="number" v-model="newRecord.priority" class="form-control" style="width: 100px;" placeholder="Priority" v-if="newRecord.type === 'MX'">
          </td>
          <td>
            <button class="btn btn-primary btn-sm" @click="editRecord(newRecord)"><i class="fa fa-save"></i> Save</button>
            <button class="btn btn-danger btn-sm" @click="showAddRecord = false; $forceUpdate()"><i class="fa fa-remove"></i> Cancel</button>
          </td>
        </tr>
        </tbody>
        <tbody>
        <template v-for="rec in dnsRecords.data.result">
          <tr :key="rec.id + '-1'" v-if="!editing[rec.id]">
            <td>
              {{ rec.type }}
              <i class="fa fa-long-arrow-alt-right green" v-if="rec.proxied" v-tooltip="'Record proxied'"></i>
              <i class="fa fa-remove orange" v-else v-tooltip="'Record not proxied'"></i>
            </td>
            <td>{{ rec.name }}</td>
            <td :title="rec.content">
              {{ shorten(rec.content, 50) }}
              <span v-if="rec.priority" class="label label-primary m-l-sm">{{ rec.priority }}</span>
            </td>
            <td>
              <i class="fa fa-edit pointer" v-tooltip="'Edit record'" @click="editing[rec.id] = true; $forceUpdate()"></i>
              <i class="fa fa-remove pointer" v-tooltip="'Delete record'" @click="deleteRecord(rec.id)"></i>
            </td>
          </tr>
          <tr :key="rec.id + '-2'" v-if="editing[rec.id]">
            <td>
              <v-select
                :options="recordTypes"
                v-model="rec.type"
                placeholder="Type"
              ></v-select>
              <input type="checkbox" name="" id="" v-tooltip="'Proxied'" v-model="rec.proxied">
            </td>
            <td>
              <input type="text" class="form-control" v-model="rec.name">
            </td>
            <td>
              <input type="text" v-model="rec.content" class="form-control">
              <input type="number" v-model="rec.priority" class="form-control" style="width: 100px;" placeholder="Priority" v-if="rec.type === 'MX'">
            </td>
            <td>
              <button class="btn btn-primary btn-sm" @click="editRecord(rec)"><i class="fa fa-save"></i> Save</button>
              <button class="btn btn-danger btn-sm" @click="editing[rec.id] = false; $forceUpdate()"><i class="fa fa-remove"></i> Cancel</button>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { PBN_SET } from '../../../../../store/mutation-types'
import { String } from '../../../../../mixins/helperMixin'

export default {
  name: 'Cloudflare',
  data () {
    return {
      recordTypes: ['A', 'CNAME', 'AAAA', 'MX', 'HTTPS', 'TXT', 'SRV', 'LOC', 'NS', 'CERT', 'DNSKEY', 'DS', 'NAPTR', 'SMIMEA', 'SSHFP', 'SVCB', 'TLSA', 'URI'],
      dnsRecords: [],
      editing: {},
      newRecord: {},
      showAddRecord: false,
      pointsToServer: true,
      serverIps: {
        'money1.ams3.aphex.me': '174.138.1.253',
        'm1-ws1-ams3.aphex.me': '104.248.95.240',
        'pbn2.ams3.aphex.me': '178.62.194.235',
        'pbn3.ams3.aphex.me': '146.190.29.22',
        'pbn4.ctb.aphex.me': '194.163.169.14',
        'ppc1.ams3.aphex.me': '159.223.227.176'
      }
    }
  },
  mounted () {
    this.fetchDnsRecords()
  },
  mixins: [String],
  watch: {
    site () {
      this.fetchDnsRecords()
    }
  },
  computed: {
    ...mapGetters({
      site: 'getPbn',
      user: 'getUser'
    })
  },
  methods: {
    async updateCfSettings (prop, val) {
      try {
        let pbn = await axios.patch(`/pbn/site/${this.site.punyDomain}/ip-providers/cloudflare/${prop}`, {
          setting: val
        })
        this.$store.commit(PBN_SET, pbn.data)
        this.$toastr.success('Cloudflare setting successfully updated')
      } catch (e) {
        this.$toastr.error(e.response.data.msg, 'CF Update failed')
      }
    },
    async fetchDnsRecords () {
      try {
        this.dnsRecords = await axios.get(`/pbn/site/${this.site.punyDomain}/ip-providers/cloudflare/dns-records`)
        this.editing = {}
        try {
          let pointy = false
          await this.dnsRecords.data.result.forEach(r => {
            if ((r.type === 'A' || r.type === 'CNAME') && r.name === this.site.punyDomain) {
              pointy = true
            }
          })
          this.pointsToServer = pointy
        } catch (e) {
        }
      } catch (e) {
        this.$toastr.error(e)
      }
    },
    async addDefaultRecords () {
      await this.editRecord({
        name: '@',
        type: 'A',
        content: this.serverIps[this.site.customData.doServer],
        ttl: 3600,
        proxied: true
      })
      await this.editRecord({
        name: 'www',
        type: 'CNAME',
        content: this.site.punyDomain,
        ttl: 3600,
        proxied: true
      })
    },
    async editRecord (rec) {
      try {
        if (rec.id) {
          await axios.put(`/pbn/site/${this.site.punyDomain}/ip-providers/cloudflare/dns-records/${rec.id}`, {
            name: rec.name,
            type: rec.type,
            content: rec.content,
            ttl: rec.ttl,
            priority: rec.priority,
            extras: {
              proxied: rec.proxied
            }
          })
        } else {
          await axios.post(`/pbn/site/${this.site.punyDomain}/ip-providers/cloudflare/dns-records`, {
            name: rec.name,
            type: rec.type,
            content: rec.content,
            ttl: rec.ttl,
            priority: rec.priority,
            extras: {
              proxied: rec.proxied
            }
          })
          this.newRecord = {}
          this.showAddRecord = false
        }
        await this.fetchDnsRecords()
      } catch (e) {
        this.$toastr.error(e)
      }
    },
    async deleteRecord (id) {
      try {
        if (!confirm('Delete record?')) {
          return
        }
        await axios.delete(`/pbn/site/${this.site.punyDomain}/ip-providers/cloudflare/dns-records/${id}`)
        await this.fetchDnsRecords()
      } catch (e) {
        this.$toastr.error(e.data)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/Cloudflare.vue